export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU'
